// extracted by mini-css-extract-plugin
module.exports = {"primary":"_ac9d1bd1","heading":"_a887a763","attention":"_0b1a4c95","secondary":"_2d8c5e83"};